import { createContext } from 'react';

/**
 * Lets `ModalHeader` hand its heading id back up to `Modal`, so the dialog can point
 * `aria-labelledby` at it.
 *
 * A context rather than a prop because the two are siblings in the consumer's tree --
 * `<ModalContainer><ModalHeader/>...</ModalContainer>` -- so Modal cannot pass the id down
 * directly, and threading a `title` prop through Modal instead would mean touching all 55
 * call sites.
 *
 * `registerHeading` exists because only 15 of those 55 modals render a ModalHeader. Setting
 * aria-labelledby unconditionally would leave a dangling IDREF on the other 40, which is
 * invalid ARIA and computes to the same empty name we already had. CORE-78924.
 */
const ModalHeadingContext = createContext(null);

export default ModalHeadingContext;
